import React from "react";
import { Chip } from "@mui/material";

export default function ImageTag({ tag }) {
  if (!tag || typeof tag != "string") return;
  return (
    <Chip
      label={tag.toUpperCase()}
      style={{ backgroundColor: "#45C4B0", color: "#012030" }}
    />
  );
}
